import { render } from "./GroupCDetails.vue?vue&type=template&id=01459b28&scoped=true"
import script from "./GroupCDetails.vue?vue&type=script&lang=js"
export * from "./GroupCDetails.vue?vue&type=script&lang=js"

import "./GroupCDetails.vue?vue&type=style&index=0&id=01459b28&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01459b28"]])

export default __exports__